import React from 'react';
import { showNotificationPopup } from '../../../Elements/NotificationPopupHost';

function NotificationDemoComponent() {
  const fireMessage = () =>
    showNotificationPopup({
      id: 'messages',
      count: 5,
      title: '5 unread messages',
      preview: { from: 'Demo Sender', subject: 'Q3 shop visit follow-up' },
      glyph: 'fa-solid fa-envelope',
      ctaLabel: 'View inbox',
      onView: () => {},
    });

  const fireDownload = () =>
    showNotificationPopup({
      id: 'downloads',
      count: 1,
      title: 'Export ready to download',
      accent: 'info',
      glyph: 'fa-solid fa-download',
      ctaLabel: 'Open downloads',
      onView: () => {},
    });

  return (
    <div className='dsg-row'>
      <button
        type='button'
        className='btn'
        onClick={fireMessage}
      >
        <i className='fa-solid fa-envelope' /> Fire message popup
      </button>
      <button
        type='button'
        className='btn'
        onClick={fireDownload}
      >
        <i className='fa-solid fa-download' /> Fire download popup (info accent)
      </button>
    </div>
  );
}

export const notificationDemo = {
  id: 'notification-popup',
  title: 'Notification popups',
  category: 'Overlays & Editing',
  importPath: 'Elements/NotificationPopupHost (showNotificationPopup)',
  notes: [
    'Trigger from anywhere with showNotificationPopup(config) — the single NotificationPopupHost mounted in app.js renders the top-center stack. Never mount a second host.',
    'Same id replaces the existing popup in place (e.g. rising unread count).',
    "Auto-dismisses after 7 seconds; accent: 'info' switches the red avatar to sky.",
  ],
  snippet:
    "showNotificationPopup({\n  id: 'messages',\n  count: unreadCount,\n  title: unreadCount + ' unread messages',\n  glyph: 'fa-solid fa-envelope',\n  ctaLabel: 'View inbox',\n  onView: () => openPage('messages'),\n});",
  render: NotificationDemoComponent,
};
